module.exports = __webpack_public_path__ + "assets/4a4146fbcd3cdd48bc619718d58fcd9c.mp4";